import { LOCAL_STORAGE_AMBASSADOR_ID_KEY } from "../utils/constants.js";

export const saveAmbassadorIdInLocalStorage = (ambassadorId: string) => {
    localStorage.setItem(LOCAL_STORAGE_AMBASSADOR_ID_KEY, ambassadorId);
};

export const getAmbassadorIdFromLocalStorage = () => {
    return localStorage.getItem(LOCAL_STORAGE_AMBASSADOR_ID_KEY) ?? undefined;
};
